import security from '../assets/security.webp';

const badges = [
  { icon: '🔒', label: 'End-to-End Encryption' },
  { icon: '🛡️', label: 'AML Compliance' },
  { icon: '✅', label: 'KYC Verified' },
  { icon: '🔐', label: '2FA Protected' },
];

function SectionLast() {
  return (
    <section className="bg-[#080812] py-16 relative overflow-hidden">
      {/* Background blur circle */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-violet-900/20 blur-3xl rounded-full"></div>

      {/* Container */}
      <div className="container mx-auto px-2 relative z-10">
        <div className="bg-gradient-to-br from-white/5 to-white/2 border border-white/10 rounded-3xl overflow-hidden backdrop-blur-sm">
          <div className="flex flex-col lg:flex-row items-center gap-0">

            {/* Content */}
            <div className="flex-1 p-12 lg:p-16">
              <span className="inline-block text-violet-400 text-xs font-bold tracking-widest uppercase mb-5 bg-violet-500/10 px-3 py-1.5 rounded-full border border-violet-500/20">
                Security & Compliance
              </span>

              <h2 className="text-4xl lg:text-5xl font-black text-white mb-6 leading-tight">
                Your assets are<br />
                <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
                  always protected.
                </span>
              </h2>

              <p className="text-gray-400 text-lg leading-relaxed mb-10 max-w-lg">
                We apply the highest security standards in the industry, partnering with regulatory bodies to ensure your funds are safe, compliant, and fully insured.
              </p>

              {/* Compliance badges */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
                {badges.map((b) => (
                  <div
                    key={b.label}
                    className="flex flex-col items-center justify-center gap-2 bg-white/5 border border-white/8 rounded-xl px-2 py-2 hover:bg-white/10 transition"
                  >
                    <span className="text-md">{b.icon}</span>
                    <span className="text-white text-base font-semibold">{b.label}</span>
                  </div>
                ))}
              </div>

              <button className="group inline-flex items-center gap-3 bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-bold px-7 py-3.5 text-xs rounded-2xl hover:opacity-90 transition-all hover:shadow-lg hover:shadow-violet-500/25 hover:-translate-y-0.5">
                Learn About Security
                <span className="transition-transform group-hover:translate-x-1">→</span>
              </button>
            </div>

            {/* Image */}
            <div className="flex-1 flex justify-center items-center p-8 lg:p-12">
              <div className="relative">
                <div className="absolute -inset-8 bg-gradient-to-br from-violet-600/20 to-indigo-600/10 blur-3xl rounded-full"></div>
                <img
                  src={security}
                  alt="Security"
                  className="relative w-full max-w-sm object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionLast;